/** @file fitZoomFor: the integer upscale that frames a puppet's height in about 65 % of the view. */

/** Share of the viewport height the puppet's rest height should fill, and the upscale range. */
const SHARE = 0.65;
const MIN = 1;
const MAX = 8;

/**
 * The largest integer upscale in 1..8 with `boundsHeightUnits x pixelsPerUnit x scale` device pixels within 65 % of
 * the view's device height (`viewportCssHeight x dpr`). A puppet with no height gets the largest upscale.
 */
export function fitZoomFor(boundsHeightUnits: number, viewportCssHeight: number, pixelsPerUnit: number, dpr = 1): number {
  const px = boundsHeightUnits * pixelsPerUnit;
  if (!(px > 0)) return MAX;
  return Math.min(MAX, Math.max(MIN, Math.floor((SHARE * viewportCssHeight * dpr) / px)));
}
